import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { SidebarEmptyState } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Image, Stack } from '@lyearn/ui';
import { ProviderType } from '@/types/schema';
import { grayScale } from '@/utils/styles';

type EmptyStateProps = {
  onAddQuery: () => void;
  provider: ProviderType;
};

function EmptyStateComp(props: EmptyStateProps) {
  const { t } = useTranslation('Jira');
  const { onAddQuery, provider } = props;

  return (
    <Stack alignItems="center" className="h-full p-32" direction="col" justifyContent="center">
      <Image
        alt={provider.name}
        className={cn(grayScale, 'h-32 w-32 opacity-50')}
        src={provider.logo.url!}
      />
      <SidebarEmptyState
        description={t('Jira:NoSyncsYet')}
        primaryAction={{
          label: t('Jira:AddJQLQuery'),
          onClick: onAddQuery,
        }}
      />
    </Stack>
  );
}

export default EmptyStateComp;
